import { Button, Col, Form, type FormInstance, Input, Row } from 'antd';
import type React from 'react';
import type { DiagnoseCreateInput, DiagnoseUpdateInput } from '../../../../graphql/generated/graphql.ts';

export const DiagnoseForm: React.FC<{
  form: FormInstance;
  initialValues?: DiagnoseCreateInput;
  onFinish: (values: DiagnoseCreateInput | DiagnoseUpdateInput) => void;
  nameValidator: (name: string) => boolean;
}> = ({ form, initialValues, onFinish, nameValidator }) => {
  return (
    <Form layout="vertical" form={form} initialValues={initialValues} onFinish={onFinish}>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Bezeichnung"
            rules={[
              {
                required: true,
                whitespace: true,
              },
              {
                validator: (_, name) => (nameValidator(name) ? Promise.resolve() : Promise.reject('Dieser Name ist bereits vergeben')),
              },
            ]}
          >
            <Input autoFocus />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="icd10" label="ICD-10">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="text"
        label="Text"
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      {/* hack for enter button support */}
      <Button htmlType="submit" hidden />
    </Form>
  );
};
